import { SubscriptionCadence } from '../../../util/subscription-cadence';

const CENTS_IN_DOLLAR = 100;

export const getCurrentSubscriptionMonthlyCost = (
  currentSubscriptionCadence: SubscriptionCadence | null,
  subscriptionPriceItems: Array<PriceItemV3>,
) => {
  const subscriptionCadence = currentSubscriptionCadence || SubscriptionCadence.MONTHLY;
  const totalAmount = (subscriptionPriceItems || []).reduce(
    (sum, priceItem) => sum + (priceItem.amount || 0),
    0,
  );
  return subscriptionCadence === SubscriptionCadence.MONTHLY ? totalAmount : totalAmount / 12;
};

const getPriceItem = (basePrices: Array<StripePriceV3>, itemizedPriceType: ItemizedPriceType) =>
  (basePrices || []).find((price) => price.itemizedPriceType === itemizedPriceType);

export const getCalculatedItemMonthlyCost = (
  basePrices: Array<StripePriceV3>,
  quantity: number | null,
  itemizedPriceType: ItemizedPriceType,
) => {
  if (!quantity) {
    return 0;
  }

  const priceItem = getPriceItem(basePrices, itemizedPriceType);

  if (!priceItem || quantity === null) {
    return null;
  }

  if (priceItem.amount) {
    return (priceItem.amount * quantity) / CENTS_IN_DOLLAR;
  }

  const firstMatchingTier = priceItem?.tiers?.find(
    (tier, index) => (tier.upTo || 0) >= quantity || index === (priceItem.tiers || []).length - 1,
  );

  return (firstMatchingTier?.flatAmount || 0) / CENTS_IN_DOLLAR;
};
